module.exports = __webpack_public_path__ + "static/img/4467_phase_function_Paper_PointsHejduk_Prediction.b6bba7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4467_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 8pqE
// module chunks = 0